<template>
    <job-sheets-find
        :params="{
            job_sheet: $route.params.job_sheet
        }"
        :include="[
            'contacts',
            'entries(include:files(filters:with_erased=false))',
            'maintenance(include:files(filters:with_erased=false),property(include:landlord))',
        ]"
        v-slot="{
            data: job_sheet,
            has_loaded,
            is_loading,
            error,
            find
        }"
    >
        <div v-if="!has_loaded || error">
            <base-loading
                :error="error"
                :retry="find"
                class="py-6"
            />

            <error-modal
                v-if="error"
                :error="error"
            />
        </div>

        <div v-else>
            <base-hint name="landlords-job-sheets-show">
                <template slot="heading">
                    Viewing a job sheet
                </template>

                <p>
                    ...
                </p>
            </base-hint>

            <with-variables
                :variables="{
                    contact: _.get(job_sheet, 'contacts.data[0]')
                }"
                v-slot="{ contact }"
            >
                <details-card class="mb-6 id-details-card">
                    <template slot="header">
                        <div class="flex-grow mr-3 overflow-hidden">
                            <h1 class="text-lg font-normal truncate">
                                {{ _.possession(contact.name) }} Job Sheet
                            </h1>
                        </div>

                        <div
                            v-if="is_loading"
                            class="w-6 h-6"
                        >
                            <base-svg
                                name="icon-loading"
                                class="w-full h-full"
                            />
                        </div>
                    </template>
                    <template slot="body">
                        <grid-layout>
                            <grid-layout-item class="mb-3 sm:w-1/2 md:w-1/3">
                                <div class="text-xs text-label">Contact</div>
                                <div class="text-sm">
                                    <router-link
                                        :to="{
                                            name: $router.fix('dashboard.*.contacts.show'),
                                            params: {
                                                contact: contact.uuid
                                            }
                                        }"
                                        class="text-blue"
                                    >
                                        {{ contact.name }}
                                    </router-link>
                                </div>
                            </grid-layout-item>

                            <grid-layout-item class="mb-3 sm:w-1/2 md:w-1/3">
                                <div class="text-xs text-label">Email</div>
                                <div class="text-sm">
                                    <base-na />
                                </div>
                            </grid-layout-item>

                            <grid-layout-item class="mb-3 sm:w-1/2 md:w-1/3">
                                <div class="text-xs text-label">Telephone</div>
                                <div class="text-sm">
                                    +447446994

                                    <base-tooltip
                                        class="inline-block"
                                    >
                                        <base-svg
                                            slot="trigger"
                                            name="icon-important-circle"
                                            class="inline-block w-4 h-4 -mt-1"
                                        />

                                        <template slot="tooltip">
                                            This doesn't appear to be a valid number.
                                        </template>
                                    </base-tooltip>

                                    <base-tooltip
                                        class="inline-block"
                                    >
                                        <base-svg
                                            slot="trigger"
                                            name="icon-check-circle"
                                            class="inline-block w-4 h-4 -mt-1 fill-primary-white fill-secondary-green"
                                        />

                                        <template slot="tooltip">
                                            We've sent a link to the job sheet to this telephone number.
                                        </template>
                                    </base-tooltip>
                                </div>
                            </grid-layout-item>
                        </grid-layout>
                    </template>
                </details-card>
            </with-variables>

            <div class="mb-6 bg-white rounded shadow">
                <header class="flex items-center h-16 px-4 bg-white border-b rounded-t sm:px-6">
                    <h3 class="flex-grow text-base font-normal">Shared link</h3>
                </header>

                <div class="flex-grow px-4 py-4 text-grey-darker sm:px-6">
                    <p class="mb-3">
                        We've [emailed and text] this link to the contact you assigned to this job sheet - but
                        if you wish to personally send them a link, share this:
                    </p>

                    <form-item
                        name="link"
                        class="mb-0!"
                    >
                        <template slot="label">Link to job sheet</template>

                        <div class="flex">
                            <input-clipboard
                                name="link"
                                :value="job_sheet.links.www.show"
                            />
                        </div>

                        <template slot="hint">Share this link with the contractor</template>
                    </form-item>
                </div>
            </div>

            <div class="mb-6 bg-white rounded shadow">
                <header class="flex items-center h-16 px-4 bg-white border-b rounded-t sm:px-6">
                    <h3 class="flex-grow text-base font-normal">Timeline</h3>
                </header>

                <div class="px-4 py-6 sm:px-6">
                    <job-sheet-entries-list
                        :job-sheet="job_sheet"
                        :entries="job_sheet.entries.data"
                    />

                    <div class="relative pt-10">
                        <div class="pl-10">
                            <router-link
                                :to="{
                                    path: '#'
                                }"
                                class="btn btn-blue btn-with-icon"
                            >
                                <div class="flex items-center justify-center">
                                    <base-svg
                                        name="icon-add-circle"
                                        class="w-6 h-6 mr-2"
                                    />

                                    New Comment
                                </div>
                            </router-link>
                        </div>

                        <div
                            class="absolute border-2 border-l rounded"
                            :style="{
                                top: '-10px',
                                left: '10px',
                                bottom: '20px'
                            }"
                        />

                        <div
                            class="absolute border-2 border-t rounded"
                            :style="{
                                width: '15px',
                                left: '10px',
                                bottom: '20px'
                            }"
                        />
                    </div>
                </div>
            </div>
        </div>
    </job-sheets-find>
</template>

<script>
    import DetailsCard from '../../../../components/details-card'
    import JobSheetsFind from '../../../../components/job-sheets-find'
    import JobSheetEntriesList from '../../../../components/job-sheet-entries-list'

    export default {
        components: {
            DetailsCard,
            JobSheetsFind,
            JobSheetEntriesList
        }
    }
</script>
